export var GlobalEvents = {
    AppIsUnloading: 'global:app-unloading',
    ApplicationReady: 'global:app-ready',
    InjectNavigation: 'global:inject-navigation',
    InjectRouters: 'global:inject-routers',
    InjectSettingsTab: 'global:inject-settings-tab',
    GetSettingsTab: 'global:get-settings-tab'
};

//# sourceMappingURL=GlobalEvents.js.map